<template>
    <div class="optionboard-phonemic-consonant">
        <div class="optionboard-phonemic-consonant__feature-type">
            <span class="optionboard-phonemic-consonant__feature-label">ÇIKIŞ YERİ</span>
            <div class="optionboard-phonemic-consonant__feature-options">
                <BtnOptionPhonemicConsonant
                    v-for="placeOption in placeOptions"
                    featureType="place"
                    :optionSlug="placeOption"
                    :optionText="$t('consonant.place.' + placeOption)"
                    @click="selectPlace(placeOption)" />
            </div>
        </div>

        <div class="optionboard-phonemic-consonant__feature-type">
            <span class="optionboard-phonemic-consonant__feature-label">ÇIKIŞ BİÇİMİ</span>
            <div class="optionboard-phonemic-consonant__feature-options">
                <BtnOptionPhonemicConsonant
                    v-for="mannerOption in mannerOptions"
                    featureType="manner"
                    :optionSlug="mannerOption"
                    :optionText="$t('consonant.manner.' + mannerOption)"
                    @click="selectManner(mannerOption)" />
            </div>
        </div>

        <div class="optionboard-phonemic-consonant__feature-type">
            <span class="optionboard-phonemic-consonant__feature-label">ÖTÜMLÜLÜK</span>
            <div class="optionboard-phonemic-consonant__feature-options">
                <BtnOptionPhonemicConsonant
                    featureType="voicing"
                    optionSlug="voiced"
                    :optionText="$t('consonant.voicing.voiced')"
                    @click="selectVoicing('voiced')" />
                <BtnOptionPhonemicConsonant
                    featureType="voicing"
                    optionSlug="voiceless"
                    :optionText="$t('consonant.voicing.voiceless')"
                    @click="selectVoicing('voiceless')" />
            </div>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import BtnOptionPhonemicConsonant from '@/components/BtnOptionPhonemicConsonant.vue';


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        components: {
            BtnOptionPhonemicConsonant,
        },

        props: {
            placeOptions:   { type: Array, default: [] },
            mannerOptions:  { type: Array, default: [] },
        },

        methods: {
            selectPlace(answerDataPlace){
                this.$store.commit('setAnswerDataPlace', answerDataPlace);
            },

            selectManner(answerDataManner){
                this.$store.commit('setAnswerDataManner', answerDataManner);
            },

            selectVoicing(answerDataVoicing){
                this.$store.commit('setAnswerDataVoicing', answerDataVoicing);
            }
        }
    };
</script>

<style scoped src="@/css/components/optionboard-phonemic-consonant.css"></style>